import { setMachineNoteDetailsData } from '../../../redux/machineNoteDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import MachineNoteDetailsHeader from './machineNoteDetailsHeader';
import MachineNoteDetailsInfo from './machineNoteDetailsInfo';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const MachineNoteDetails = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchMachineNoteDetails = useCallback(async () => {
        try {
            const { status, data } = await axios.get(`machine-note/${location.state}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setMachineNoteDetailsData(data));
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error Fetching machine_note:', error);
            CustomErrorLogger(error, "Fetch machine_note Details Error in MachineNoteDetails");
        }
    }, [dispatch, location.state]);

    useEffect(() => {
        fetchMachineNoteDetails()
    }, [fetchMachineNoteDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <MachineNoteDetailsHeader />
                    <MachineNoteDetailsInfo />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default MachineNoteDetails;